import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ProcedureType } from "../../../../../../autogen/bff-api";
import { EspdGuidingMessage } from "./EspdGuidingMessage";
import { EspdPreviewPart } from "./EspdPreviewPart";

const APPLIES_TO: ReadonlyArray<ProcedureType> = [
  ProcedureType.Restricted,
  ProcedureType.NegotiatedWithPriorCall,
  ProcedureType.CompetitiveDialogue,
  ProcedureType.InnovationPartnership,
  ProcedureType.CompetitiveNegotiation,
];

interface Props {
  procedureType: ProcedureType | null | undefined;
}

export const EspdPreviewDelV = ({ procedureType }: Props) => {
  const { t } = useTranslation();
  const applies = procedureType != null && APPLIES_TO.includes(procedureType);

  return (
    <EspdPreviewPart eyebrow={t("Part V")} title={t("Reduction of candidates")} owner="conditional">
      {applies ? (
        <EspdGuidingMessage>
          {t("The supplier confirms that they meet objective and non-discriminatory criteria for selection to the next round.")}
        </EspdGuidingMessage>
      ) : (
        <Text fontSize="sm" color="smMuted" fontStyle="italic">
          {procedureType
            ? t("Not displayed because the procedure type is {{label}}.", { label: t(procedureType) as string })
            : t("Not displayed because the procedure type does not require it.")}
        </Text>
      )}
    </EspdPreviewPart>
  );
};
